module.exports = __webpack_public_path__ + "media/7.6e9c2f57.mp3";